<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useWgptAuditTrail } from 'dashboard/composables/wgpt/wgptAuditTrail';
import Button from 'next/button/Button.vue';
import DisconnectZidDialog from './DisconnectZidDialog.vue';
import ZidWebhookSettings from './ZidWebhookSettings.vue';
import InboxSettings from './InboxSettings.vue';
import OrdersSettings from './OrdersSettings.vue';
import AuditTrails from './ZidEditorAuditTrails.vue';

const props = defineProps({
  appId: {
    type: String,
    required: true,
  },
  hookId: {
    type: Number,
    required: true,
  },
  automationId: {
    type: Number,
    default: null,
  },
  config: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const uiFlags = useMapGetter('wgptIntegrations/getUIFlags');
const { isFeatureEnabled } = useWgptAuditTrail();

const disconnectZidDialog = ref(false);

const openDisconnectPopup = () => {
  disconnectZidDialog.value?.open({
    appId: props.appId,
    hookId: props.hookId,
  });
};
</script>

<template>
  <div class="p-6 flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-medium leading-6 text-n-slate-12">
        <span class="truncate">
          {{ t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.TITLE') }}
        </span>
      </h3>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.DESCRIPTION') }}
      </p>
    </div>

    <div class="flex">
      <Button
        size="sm"
        ruby
        :label="t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.DISCONNECT_BUTTON')"
        :is-loading="uiFlags.isDeletingZid"
        :disabled="uiFlags.isDeletingZid"
        @click.prevent="openDisconnectPopup"
      />
    </div>

    <div class="border-t border-n-weak" />

    <InboxSettings :config="config" />

    <div class="border-t border-n-weak" />

    <OrdersSettings :config="config" />

    <div class="border-t border-n-weak" />

    <ZidWebhookSettings />

    <div class="border-t border-n-weak" />

    <AuditTrails v-if="isFeatureEnabled" :automation-id="automationId" />

    <DisconnectZidDialog ref="disconnectZidDialog" />
  </div>
</template>
